import { render, staticRenderFns } from "./OperaOrderDetailWindow.vue?vue&type=template&id=1ccbd7ff&scoped=true&"
import script from "./OperaOrderDetailWindow.vue?vue&type=script&lang=js&"
export * from "./OperaOrderDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaOrderDetailWindow.vue?vue&type=style&index=0&id=1ccbd7ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbd7ff",
  null
  
)

export default component.exports